import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Selecao } from 'src/app/models/selecao';

@Component({
  selector: 'app-selecao-modal',
  templateUrl: './selecao-modal.component.html',
  styleUrls: ['./selecao-modal.component.scss']
})
export class SelecaoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  titulo = '';
  opcoes: Selecao[] = [];

  constructor(public dialogRef: MatDialogRef<SelecaoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.titulo = this.data.titulo;
    this.opcoes = this.data.opcoes;
  }

  selecionar(opcao: Selecao){
    this.dialogRef.close(opcao);
  }

  fechar() {
    this.dialogRef.close();
  }

}
